import { IAuditNode, IFormularLink } from '@alberta/konexi-shared';
import { createObject } from 'src/app/common/tracking/object-creator';
import { ignore, tracked } from 'src/app/common/tracking/tracker';

import { AuditNodeResponse } from './audit-node-response-view-model';
import { Selectables } from './selectables-view-model';

export class AuditNodeViewModel implements IAuditNode {
  @ignore(true)
  isSystemNode;
  @ignore(true)
  id;

  @tracked({ factory: createObject(AuditNodeResponse) })
  responses: AuditNodeResponse[] = [];
  @ignore(true)
  color;
  @ignore(true)
  description;
  @ignore(true)
  mandatory;
  @ignore(true)
  nodeType_Id;

  @ignore(true)
  options;
  @ignore(true)
  parentId;
  @ignore(true)
  systemNode;
  @ignore(true)
  failedResponse;

  @tracked({ factory: createObject(Selectables) })
  selectables: Selectables[] = [];
  @ignore(true)
  title;
  @ignore(true)
  unit;

  @tracked({ factory: createObject(AuditNodeViewModel) })
  children: AuditNodeViewModel[] = [];
  @ignore(true)
  conditionTriggerId;
  @ignore(true)
  conditionId;
  @ignore(true)
  templateNodeId;
  @ignore(true)
  inactive;
  @ignore()
  component;
  @tracked()
  globalType: string;
  @ignore(true)
  characterLimit;
  @ignore(true)
  _name: string;
  @ignore(true)
  allowDrawPicture: boolean;
  @ignore(true)
  hidden: boolean;
  @ignore(true)
  linked: IFormularLink;
}
